import { bigScreen_emptylayout_children } from "dependencies/emptyLayout/index.js"
export default {
  name: "自由布局",
  id: "",
  // type: "emptyLayoutComponentBigScreen",
  type: "layoutComponentBigScreen",
  children: bigScreen_emptylayout_children,
  sort: 120
}
